import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "chat_end",
  class: "chat-end",
  "aria-hidden": "true"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AiAssistant = _resolveComponent("AiAssistant")
  const _component_UserMessage = _resolveComponent("UserMessage")
  const _component_AIMessage = _resolveComponent("AIMessage")
  const _component_UserCancelled = _resolveComponent("UserCancelled")
  const _component_ChatError = _resolveComponent("ChatError")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_DownButton = _resolveComponent("DownButton")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-chat", [$props.mode]])
  }, [
    _withDirectives((_openBlock(), _createBlock(_component_ScrollBar, {
      ref: "scroller",
      class: "scroller",
      fade: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.history, (item, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.type === 'assistant')
              ? (_openBlock(), _createBlock(_component_AiAssistant, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "chat-id": $props.chatId,
                  class: "entry delay-in-1000",
                  mode: $props.mode,
                  item: item,
                  "last-answer": $options.last_answer_idx === idx,
                  generating: $props.generating,
                  idx: idx,
                  readonly: $props.readonly,
                  restricted: idx <= $props.refHistoryLen,
                  onTextAdded: _cache[0] || (_cache[0] = $event => (_ctx.$emit('text-added', $event))),
                  onAskAi: _cache[1] || (_cache[1] = $event => (_ctx.$emit('ask-ai', $event))),
                  onLike: $event => (_ctx.$emit('like', {idx, feedback: $event})),
                  onDislike: $event => (_ctx.$emit('dislike', {idx, feedback: $event})),
                  onSave: $event => (_ctx.$emit('save', {idx, text: $event})),
                  onRefrag: $event => (_ctx.$emit('refrag', {idx, range: $event})),
                  onOnboardingCompleted: _cache[2] || (_cache[2] = $event => (_ctx.$emit('onboarding-completed', $event)))
                }, null, 8 /* PROPS */, ["chat-id", "mode", "item", "last-answer", "generating", "idx", "readonly", "restricted", "onLike", "onDislike", "onSave", "onRefrag"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'user')
              ? (_openBlock(), _createBlock(_component_UserMessage, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "copied-title": idx === 0 && !!$props.refHistoryLen,
                  data: item.data,
                  class: "user-message entry delay-in-1000",
                  mode: $props.mode,
                  onPromptSave: $event => (_ctx.$emit('prompt-save', {idx}))
                }, null, 8 /* PROPS */, ["copied-title", "data", "mode", "onPromptSave"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'assistant-error')
              ? (_openBlock(), _createBlock(_component_AIMessage, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  error: "",
                  class: "ai-message entry delay-in-1000",
                  text: item.data.text
                }, null, 8 /* PROPS */, ["text"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'user-cancelled')
              ? (_openBlock(), _createBlock(_component_UserCancelled, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  class: "entry delay-in-1000",
                  mode: $props.mode,
                  text: item.data.text
                }, null, 8 /* PROPS */, ["mode", "text"]))
              : _createCommentVNode("v-if", true),
            (item.type === 'error')
              ? (_openBlock(), _createBlock(_component_ChatError, {
                  key: idx,
                  ref_for: true,
                  ref: "history",
                  "chat-id": $props.chatId,
                  data: item.data,
                  class: "entry delay-in-1000",
                  mode: $props.mode
                }, null, 8 /* PROPS */, ["chat-id", "data", "mode"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        }), 256 /* UNKEYED_FRAGMENT */)),
        _createElementVNode("div", _hoisted_1, null, 512 /* NEED_PATCH */)
      ]),
      _: 1 /* STABLE */
    })), [
      [_directive_resize, $options.setClientHeight]
    ]),
    _createVNode(_component_DownButton, {
      visible: $data.show_down,
      generating: $props.generating,
      onScroll: $options.scrollToEnd
    }, null, 8 /* PROPS */, ["visible", "generating", "onScroll"])
  ], 2 /* CLASS */))
}